module.exports = __webpack_public_path__ + "static/media/logo-square.e999809f.png";